// extracted by mini-css-extract-plugin
module.exports = {"ContactLink":"ContactLink_ContactLink__23o7V","Email":"ContactLink_Email__3Bhqx","Phone":"ContactLink_Phone__1O7IX"};